import { lazy } from 'react';
export var AchievementsPageAsync = lazy(function () { return import('./AchievementsPage'); });
